module.exports = __webpack_public_path__ + "img/home-process-1.18c803e1.png";